<!-- WonderYjjPopular.vue -->
<template>
	<div>
		<div class="row">
			<div class="col col-md-2 col-sm-3">
				<KingStocks @p_show_kline="show_kline" @date-selected="handleDateSelected"></KingStocks>
			</div>
			<div class="col col-md-10 col-sm-9" v-if="symbol_code">
				<StockMultiChart :symbol_code="symbol_code" :symbol_name="symbol_name" :selectedDate="selectedDate" :chart_width="'900px'">
				</StockMultiChart>

				<div role="group">
					<label for="input-live">股票代码:</label>
					<b-form-input id="input-symbol_code" v-model="symbol_code" :state="nameState"
						aria-describedby="input-live-help input-live-feedback" placeholder="6位股票代码" trim
						style="width: 200px;"></b-form-input>
					<b-form-invalid-feedback id="input-live-feedback">
						请输入6位股票代码
					</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	import KingStocks from 'components/quant/KingStocksTable.vue'
	import StockMultiChart from 'components/stock/StockMultiChart.vue'

	export default {
		data() {
			return {
				days: [],
				symbol_name: "",
				symbol_code: null,
				selectedDate: null,
			};
		},
		computed:{
			nameState() {
				if (this.symbol_code.length == 6){
					return true
				}
				return false
			}
		},
		components: {
			KingStocks,
			StockMultiChart
		},
		methods: {
			show_kline(symbol_code){
				this.symbol_code = symbol_code
				console.log(symbol_code)
			},
			handleDateSelected(newDate) {
				this.selectedDate = newDate; // Update selectedDate when the date-selected event is emitted
			},
			handleShowKline(symbol_code) {
				this.symbol_code = symbol_code
				// console.log(symbol_code)
			},
		}
	}
</script>

<style>
</style>